export default __webpack_public_path__ + "static/media/addendum-preview.77c52c54.svg";